export default __webpack_public_path__ + "static/media/element_7.4b8d3ec7.avif";